import React from "react"

import { VALUE, UNLIMITED, NO, YES } from "const"
import { MtPackage } from "server/models"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"

import TableSelect from "../components/select"

const Drive = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "driveSpace",
            header: lang.driveSpace,
            formatter: (packg: MtPackage) => {
                const { driveSpace, driveSpaceValue } = packg.settingsParsed
                if (driveSpace === 0) return "0 GB"
                if (driveSpace === VALUE) return `${driveSpaceValue} GB`
                if (driveSpace === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { driveSpace, driveSpaceValue } = packg.settingsParsed
                let title = ""
                if (driveSpace === 0) title = "0 GB"
                if (driveSpace === VALUE) title = `${driveSpaceValue} GB`
                if (driveSpace === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.driveSpaceGB}
                        property={{ driveSpace }}
                        propertyValue={{ driveSpaceValue }}
                        propertyArray={[0, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "cloudDrivesAllowed",
            header: lang.cloudDrivesAllowed,
            formatter: (packg: MtPackage) => {
                const { cloudDrivesAllowed } = packg.settingsParsed
                return lang[cloudDrivesAllowed]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { cloudDrivesAllowed } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[cloudDrivesAllowed]}
                        label={lang.cloudDrivesAllowed}
                        property={{ cloudDrivesAllowed }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Drive
